import * as actionTypes from 'modules/audits/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

const open = () => true;

const close = () => false;

export default createReducer(initialState, {
  [actionTypes.OPEN_SHARE_MODAL]: open,
  [actionTypes.CLOSE_SHARE_MODAL]: close,
  [actionTypes.SHARE_AUDIT_SUCCESS]: close,
});
